import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CtaLink from 'components/essentials/Cta/CtaLink';
import TextPlaceholder from 'components/consumer/TextPlaceholder';
const ItemPlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span><TextPlaceholder className="w-1/2 md:!w-[50px] !inline-flex !mt-1 md:!mt-0" /></span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const BreadcrumbItem = props => {
  const $ = _c(12);
  const {
    link,
    loading: t0,
    isLast: t1,
    backIcon: t2
  } = props;
  const loading = t0 === undefined ? false : t0;
  const isLast = t1 === undefined ? false : t1;
  const backIcon = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== backIcon || $[1] !== isLast || $[2] !== link || $[3] !== loading || $[4] !== props.backArrowIcon || $[5] !== props.label) {
    t3 = isLast ? <span itemScope={true} itemType="https://schema.org/Thing" itemProp="item">{loading ? <ItemPlaceholder /> : <span itemProp="name" className="text-xs">{props.label}</span>}</span> : loading ? <div><ItemPlaceholder /></div> : <span className={classNames({
      "before:p-2 before:text-gray-light1 before:animate-fade-in-ease before:content-['<'] text-xs": props.backArrowIcon
    })}><CtaLink itemScope={true} itemType="https://schema.org/Thing" itemProp="item" styling="link" hasArrow={false} color="black" to={link} isBold={false}>{backIcon ? <span className="text-xl mr-2 align-middle">←</span> : null}{loading ? <ItemPlaceholder /> : <span itemProp="name" className="text-gray-light1 [a:hover_&]:text-brand [a:hover_&]:underline text-xs">{props.label}</span>}</CtaLink></span>;
    $[0] = backIcon;
    $[1] = isLast;
    $[2] = link;
    $[3] = loading;
    $[4] = props.backArrowIcon;
    $[5] = props.label;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = props.index + 1;
  let t5;
  if ($[7] !== t4) {
    t5 = <meta itemProp="position" content={t4} />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <li itemProp="itemListElement" itemScope={true} itemType="https://schema.org/ListItem" className="inline-block before:relative before:top-px before:left-0 before:text-xs before:p-2 before:text-gray-light1 before:animate-fade-in-ease before:content-['>'] first:before:hidden">{t3}{t5}</li>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
BreadcrumbItem.propTypes = {
  loading: PropTypes.bool,
  link: PropTypes.string,
  label: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isLast: PropTypes.bool,
  backIcon: PropTypes.bool,
  backArrowIcon: PropTypes.bool
};
export default BreadcrumbItem;